module.exports = "/layout/app/images/bg-scrollbar-thumb.b2b0e7e0.svg";